<script lang="ts" setup>
export interface SubmenuLinkProps {
    category: any
    isActive?: boolean
}

const props = defineProps<SubmenuLinkProps>()
const activeSubmenu = useState('activeSubmenu')
const menuProducts = useState('menuProducts')
const to = computed<VNuxtLinkTo>(() => {
    if (props.category.isExternal) {
        return props.category.slug
    }

    if (props.category.meta_product) {
        return {
            name: props.category.slug,
        }
    }

    if (!props.category.products && props.category.items.length === 0) {
        return `/${props.category.slug}`
    }

    return {
        name: 'insurance-category-detail',
        params: { id: props.category.slug },
    }
})

const handleClick = (e: Event) => {
    if (props.category.meta_product) return true

    e.stopImmediatePropagation()
    // there are no submenus, redirect
    if (!props.category.products && props.category.items.length === 0) {
        return
    }
    // prevent default
    e.preventDefault()
    // save active menu item
    activeSubmenu.value = props.category.slug
    menuProducts.value = {
        products: props.category.top_products,
        categorySlug: props.category.slug,
    }
}
</script>
<template>
  <VNuxtLink
    :to="to"
    :target="props.category.isExternal ? '_blank' : '_self'"
    :aria-current="props.isActive ? 'true' : undefined"
    class="submenu-link d-flex justify-content-between px-4 py-2 p-md-4 d-flex flex-grow-1 align-items-center text-decoration-none transiton fs-bigger"
    :class="{
      ' justify-content-md-start': !props.category.isExternal,
    }"
    @click="handleClick"
  >
    <div class="flex-shrink-0 d-flex align-items-center">
      <img
        v-if="props.category.icon?.path"
        :src="props.category.icon?.path"
        alt=""
        width="24"
        height="24"
        loading="lazy"
        decoding="async"
        class="submenu-link-icon me-3 transition d-flex align-items-center justify-content-center"
      >
      {{ props.category.title }}
    </div>

    <svg
      v-if="props.category.isExternal"
      class="d-block flex-shrink-0"
      width="16"
      height="16"
    >
      <use xlink:href="#external" />
      <title>{{ $t('Odkaz sa otvára v novom okne') }}</title>
    </svg>
  </VNuxtLink>
</template>
<style lang="scss" scoped>
@import './SubmenuLink.scss';
</style>
